import React from "react";
import { css } from "@emotion/core";
import ClipLoader from "react-spinners/ClipLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
// transform не работает, тк уже применяется transform rotate
const override = css`
  display: block;
  margin-top: 50vh;
  margin-left: 50vw;
  border-color: red;
`;

const AwesomeComponent = () => {
    return (
        <div className="sweet-loading" style={ { transform: 'translate(-7%, -50%)', }}>
            <ClipLoader
                css={override}
                size={150}
                color={"#123abc"}
                loading={ true }
            />
        </div>
    );
}

export default React.memo(AwesomeComponent);